var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.frequency.text)?_c('q-bar',{class:`col-auto bg-${_vm.frequency.color} text-white justify-center`,attrs:{"dense":""}},[_c('div',{staticClass:"col text-center text-weight-bold"},[_vm._v(" "+_vm._s(_vm.frequency.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }